import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { PvpLiveProcess } from '@/types/pvp';
import { fmtNum, istTime, simLabel } from './model';

const STATUS_COLOR: Record<PvpLiveProcess['status'], string | undefined> = {
  up: 'green',
  lost: 'red',
  stopped: undefined,
};

const columns: ColumnsType<PvpLiveProcess> = [
  { title: 'Machine', dataIndex: 'machine', key: 'machine' },
  { title: 'PID', dataIndex: 'pid', key: 'pid', align: 'right' },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status: PvpLiveProcess['status']) => <Tag color={STATUS_COLOR[status]}>{status}</Tag>,
  },
  {
    title: 'Last seen',
    dataIndex: 'lastSeen',
    key: 'lastSeen',
    render: (iso: string | undefined) => (iso ? `${istTime(iso)} IST` : '—'),
  },
  {
    title: 'Sockets',
    dataIndex: 'sockets',
    key: 'sockets',
    align: 'right',
    render: (n: number | undefined) => fmtNum(n, 0),
  },
  {
    title: 'Lag (ms)',
    dataIndex: 'lagMs',
    key: 'lagMs',
    align: 'right',
    render: (n: number | undefined) => fmtNum(n),
  },
  {
    title: 'pvp-sim',
    dataIndex: 'simUp',
    key: 'simUp',
    render: (simUp: boolean | null | undefined) => simLabel(simUp),
  },
];

/** Every PvP process seen in the last 15 minutes: up first, then lost, then stopped. */
export const ProcessTable: React.FC<{ processes: PvpLiveProcess[] }> = ({ processes }) => (
  <Table<PvpLiveProcess>
    size="small"
    rowKey={(p) => `${p.machine}:${p.pid}`}
    dataSource={processes}
    columns={columns}
    pagination={false}
    scroll={{ x: 'max-content' }}
    locale={{ emptyText: 'No PvP process seen in the last 15 minutes' }}
  />
);
